import styled from "styled-components";

/**
 * Wrapper do componente FlightPrice
 * Configura o layout principal do componente.
 */
export const StyledFlightPrice = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  background-color: ${({ theme }) => theme.colors.darkBlue};
  width: 90%;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  display: flex;
`;

/**
 * Wrapper do preço
 * Define o layout para exibir o preço formatado.
 */
export const PriceWrapper = styled.div`
  display: flex;
  width: 50%;
  justify-content: center;
  align-items: center;
`;

/**
 * Botão "Veja Mais"
 * Configura o layout e o estilo do botão de ação.
 */
export const SeeMoreButton = styled.div`
  border-radius: 0 ${({ theme }) => theme.borderRadius.large}
    ${({ theme }) => theme.borderRadius.large} 0;
  background-color: ${({ theme }) => theme.colors.yellow};
  padding: ${({ theme }) => theme.spacing(2)};
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 50%;
`;
